/**
 * PrivacyNotice - Gjenbrukbar personvern-seksjon
 * Brukes i alle modul-modaler
 */
export function PrivacyNotice({ text }) {
  const defaultText = "All behandling og lagring skjer lokalt på din enhet. Dokumenter og metadata lagres ikke på servere og deles ikke med RettVerk.";
  
  return (
    <div className="bg-[var(--bg-highlight)]/30 border border-[var(--border-subtle)] rounded-lg p-4">
      <h4 className="font-medium text-[var(--text-main)] mb-1 flex items-center gap-2">
        <span>🔒</span> Personvern
      </h4>
      <p className="text-sm text-[var(--text-muted)]">
        {text || defaultText}
      </p>
    </div>
  );
}

export default PrivacyNotice;
